module.exports = __webpack_public_path__ + "media/svg-new/flores-fa083a27.svg";